import { FC, useState } from "react";
import type { AlligatorSettings } from "../../model";
import styles from "./AcceleratorOscillatorInputsTab.module.css";

type InputKey = "jawsPeriod" | "jawsShift" | "teethPeriod" | "teethShift" | "lipsPeriod" | "lipsShift";
type InputValues = Record<InputKey, string>;

const FIELDS: { key: InputKey; label: string }[] = [
  { key: "jawsPeriod", label: "Jaws Period" },
  { key: "jawsShift", label: "Jaws Shift" },
  { key: "teethPeriod", label: "Teeth Period" },
  { key: "teethShift", label: "Teeth Shift" },
  { key: "lipsPeriod", label: "Lips Period" },
  { key: "lipsShift", label: "Lips Shift" },
];

interface Props {
  settings: AlligatorSettings;
  onChange: (settings: AlligatorSettings) => void;
}

export const AlligatorInputsTab: FC<Props> = ({ settings, onChange }) => {
  const [values, setValues] = useState<InputValues>({
    jawsPeriod: String(settings.jawsPeriod),
    jawsShift: String(settings.jawsShift),
    teethPeriod: String(settings.teethPeriod),
    teethShift: String(settings.teethShift),
    lipsPeriod: String(settings.lipsPeriod),
    lipsShift: String(settings.lipsShift),
  });

  const handleChange = (key: InputKey, value: string) => {
    setValues((prev) => ({ ...prev, [key]: value }));
  };

  const handleBlur = (key: InputKey) => {
    const parsed = parseInt(values[key], 10);
    const clamped = isNaN(parsed) ? settings[key] : Math.min(Math.max(1, parsed), 100);
    setValues((prev) => ({ ...prev, [key]: String(clamped) }));
    onChange({ ...settings, [key]: clamped });
  };

  return (
    <div className={styles.tab}>
      {FIELDS.map(({ key, label }) => (
        <div key={key} className={styles.row}>
          <span className={styles.label}>{label}</span>
          <input
            type="number"
            className={styles.input}
            min={1}
            max={100}
            value={values[key]}
            onChange={(e) => handleChange(key, e.target.value)}
            onBlur={() => handleBlur(key)}
          />
        </div>
      ))}
    </div>
  );
};
